let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fjKKq")).then(() => parcelRequire('cZDij'));